import { Button } from "@mui/material";
import styles from "./styles.module.css";
export const ActionButton = ({
  title,
  onClick,
  backgroundColor,
  color,
  ...props
}: any) => {
  return (
    <Button
      fullWidth
      variant="contained"
      size="large"
      disableElevation
      onClick={onClick}
      {...props}
      style={{
        height: "64px",
        borderRadius: "10px",
        background: backgroundColor,
        color: color,
        opacity: props.disabled ? 0.5 : 1,
      }}>
      <div className={styles.buttonTitle}>{title}</div>
    </Button>
  );
};
